module.exports = "https://static.moomoo.com/components/common-fission-share/images/line.1871fbea5e.svg";